import * as types from './types';

const initialState = {
  GetVolunteers: {},
  PostVolunteers: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_VOLUNTEERS_SUCCESS: {
      return {
        ...state,
        GetVolunteers: action.payload
      };
    }
    case types.GET_VOLUNTEERS_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_VOLUNTEERS_SUCCESS: {
      return {
        ...state,
        PostVolunteers: action.payload
      };
    }
    case types.POST_VOLUNTEERS_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
